import React, { useState } from 'react';
import { NumberModal } from './number-modal';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';
import { GridYValue, GridYUnit } from '../../../constants';

export const NumberElement = function FromElement({ element, handlerChange, error, formHasOnlyOneSubmitter }) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  const [isOpen, setIsOpen] = useState(false);
  const handelCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <label
        htmlFor={element.id}
        className="form-label"
        style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative' }}
      >
        {element.options.label} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      <input
        name={element.options.name}
        id={element.id}
        type="input"
        min={element.options.min}
        max={element.options.max}
        style={{
          height: element.options.innerElemHeight * GridYValue + GridYUnit,
          zIndex: 5000 + (element.options.zIndex || 10),
          position: 'relative',
          width: '100%',
          minHeight: 'unset',
        }}
        readOnly
        className={`form-control form-control-${element.options.size}`}
        value={element.options.valueInput}
        onClick={() => setIsOpen(true)}
      />
      <ElementErrorMessage message={error} />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}

      {isOpen && <NumberModal handelCloseModal={handelCloseModal} isOpen={isOpen} element={element} handlerChange={handlerChange} />}
    </>
  );
};
